import Fuse from "fuse.js";
import {
  GetLessonsByCourse,
  GetLessonsByStage,
  DeleteLesson,
  CreateLesson,
  UpdateLesson,
  GetStages
} from "../../../services/courses";
export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = [];
        }
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 150, 200],
        total: 0
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    sortChange({ prop, order }) {
      if (prop) {
        this.tableData.sort((a, b) => {
          let aVal = a[prop];
          let bVal = b[prop];
          if (order === "ascending") {
            return aVal > bVal ? 1 : -1;
          }
          return bVal - aVal ? 1 : -1;
        });
      } else {
        this.tableData.sort((a, b) => {
          return a.id - b.id;
        });
      }
    },
    onLoad(id) {
      if (!id) return;
      this.isLoading = true;
      GetLessonsByCourse(id).then(response => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.tableData = response.data.result;
          this.initFuse();
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onSaveLesson() {
      this.$refs.formvalid.validate().then(valid => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            CreateLesson(this.lesson).then(response => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.onLoad(this.courseId);
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateLesson(this.lesson).then(response => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.onLoad(this.courseId);
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onRefresh(){
      this.onLoad(this.courseId);
    },
    loadStages() {
      this.isLoading = true;
      GetStages(this.courseId).then(response => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.stages = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    deleteLesson(id) {
      this.isLoading = true;
      DeleteLesson(id).then(response => {
        this.isLoading = false;
        if (response.data.result) {
          this.onLoad(this.courseId);
        } else {
          this.notifyVue("danger", response.data);
        }
      });
    },
    initFuse() {
      const options = {
        keys: ["stagename", "title"],
        threshold: 0,
        shouldSort: false,
        ignoreLocation: true,
        findAllMatches: true
      };
      this.fuseSearch = new Fuse(this.tableData, options);
    }
  },
  mounted() {
    // Fuse search initialization.
    this.onLoad(this.courseId);
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
